<template>
  <el-dialog
    title="新增任务工单"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close ="handleClose">
    <el-form class="global-form1" :model="info" ref="info" :rules="rules" label-width="100px">
      <el-form-item label="工单主题" prop="orderTitle">
        <el-input v-model="info.orderTitle" placeholder="请输入工单主题" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="工单详情" prop="orderContent">
        <el-input
          type="textarea"
          maxlength="300"
          placeholder="请输入工单详情"
          :rows="6"
          show-word-limit
          v-model="info.orderContent"
        ></el-input>
      </el-form-item>
      <el-form-item label="工单类型" prop="orderType">
        <el-select v-model="info.orderType" filterable placeholder="请选择工单类型">
          <el-option
            v-for="item in typeList"
            :key="item.orderType"
            :label="item.orderTypeName"
            :value="item.orderType"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作业区域" prop="projectAreaId">
        <el-select v-model="info.projectAreaId" filterable placeholder="请选择作业区域">
          <el-option
            v-for="item in areaList"
            :key="item.projectAreaId"
            :label="item.areaName"
            :value="item.projectAreaId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作业地点" prop="address">
        <el-input v-model="info.address" placeholder="请输入作业地点" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="指派处理人" prop="orderUserId">
        <el-select v-model="info.orderUserId" filterable placeholder="请选择处理人" :disabled="info.projectId === ''">
          <el-option
            v-for="item in projectUserList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>现场图片<br>(最多六张)</span>
        </template>
        <div class="imgList">
          <template v-if="info.fileList && info.fileList.length > 0">
            <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
              <el-image
                :src="item.filePrefix + item.fileUrl"
                :preview-src-list="[item.filePrefix + item.fileUrl]"
                fit="fill">
              </el-image>
              <span></span>
              <i class="el-icon-close" @click="imgRemove(index)"></i>
            </div>
          </template>
          <UploadFile v-if="info.fileList.length < 6" @onSuccess= "onSuccess" :slotShow='true'>
            <template>
              <i class="el-icon-plus"></i>
              <p>上传图片</p>
            </template>
          </UploadFile>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'

export default {
  components: { UploadFile },
  props: {
    dialogVisible2: {
      type: Boolean,
      default: false
    },
    areaList: Array
  },
  data () {
    return {
      dialogVisible: false,
      typeList: [],
      projectUserList: [],

      info: {
        orderTitle: '', // 主题
        orderContent: '', // 详情
        orderType: '', // 类型
        projectAreaId: '', // 作业区域
        address: '', // 地点
        orderUserId: '', // 指派处理人
        fileList: [] // 文件
      },

      rules: {
        orderTitle: [
          { required: true, message: '请输入工单主题', trigger: ['blur', 'change'] }
        ],
        orderContent: [
          { required: true, message: '请输入工单详情', trigger: ['blur', 'change'] }
        ],
        orderType: [
          { required: true, message: '请选择工单类型', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入作业地点', trigger: ['blur', 'change'] }
        ],
        orderUserId: [
          { required: true, message: '请选择处理人', trigger: ['blur', 'change'] }
        ],
        fileList: [
          { required: true, message: '请选择现场图片', trigger: ['blur', 'change'] }
        ]
      }

    }
  },
  computed: {
    projectId () {
      return this.$route.query.projectId
    }

  },
  watch: {
    dialogVisible2 (val) {
      this.dialogVisible = val
    }
  },
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },

  created () {
    this.getWorkTypeList() // 工单类型
    this.getProjectUserList() // 获取项目下人员
  },

  methods: {
    // 加载工单类型
    getWorkTypeList () {
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        projectId: this.projectId,
        orderTypeStatus: '1'
      }).then((res) => {
        this.typeList = res.list || []
      })
    },

    // 获取项目下所有人信息
    getProjectUserList () {
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.projectId
      }).then((res) => {
        this.projectUserList = res || []
      })
    },

    // 文件上传成功返回
    onSuccess (file) {
      this.info.fileList.push(file)
    },

    imgRemove (index) {
      this.info.fileList.splice(index, 1)
    },

    onSubmit () {
      this.$refs.info.validate(valid => {
        if (valid) {
          const info = JSON.parse(JSON.stringify(this.info))
          // console.log('info', this.info)
          this.$emit('onAddTask', info)
          this.handleClose()
        }
      })
    },

    handleClose () {
      this.$emit('update:dialogVisible2', false)
      this.$refs.info.resetFields()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.imgList{
  display: flex;
  flex-wrap: wrap;
  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin:0 10px 10px 0;
    .el-image,img{
      width:100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }
    i:hover {
      color: #ffffff98;
    }
  }
  ::v-deep .el-upload--picture-card{
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding:25px 10px;
  }
}
</style>
